import { useEffect, useState } from 'react';
import { OpenFinanceVersion, useGetConsentsBanksQuery } from '../services/openFinanceApi';
import { ConsentConnectionStatus, ConsentPartner, ConsentStatusCode } from '../services/types';
export const POLLING_INTERVAL_MS = 5000;
export const useConsentBanks = (partyId, options) => {
    const [pollingInterval, setPollingInterval] = useState(0);
    const resultV1 = useGetConsentsBanksQuery({ partyId, version: OpenFinanceVersion.V1 }, {
        skip: options?.skip || options?.onlyPluggy,
        pollingInterval,
        refetchOnMountOrArgChange: options?.refetchOnMountOrArgChange,
        refetchOnFocus: options?.refetchOnFocus,
        refetchOnReconnect: options?.refetchOnReconnect,
    });
    const resultV2 = useGetConsentsBanksQuery({ partyId, version: OpenFinanceVersion.V2 }, {
        skip: options?.skip,
        pollingInterval,
        refetchOnMountOrArgChange: options?.refetchOnMountOrArgChange,
        refetchOnFocus: options?.refetchOnFocus,
        refetchOnReconnect: options?.refetchOnReconnect,
    });
    const consentBanksV1 = resultV1.data?.result?.map(item => ({
        ...item,
    }));
    const consentBanksV2 = resultV2.data?.result?.map(item => ({
        ...item,
    }));
    const refetch = () => {
        resultV1.refetch();
        resultV2.refetch();
    };
    const rawConsentBanks = [...(consentBanksV1 || []), ...(consentBanksV2 || [])];
    const hasConnectingConsent = rawConsentBanks.some(bank => bank.statusDetail.connectionStatus === ConsentConnectionStatus.CONNECTING &&
        bank.statusDetail.computedStatus.code === ConsentStatusCode.CONNECTING);
    useEffect(() => {
        if (!options?.autoRefreshOnConnecting) {
            return;
        }
        setPollingInterval(hasConnectingConsent ? POLLING_INTERVAL_MS : 0);
    }, [hasConnectingConsent, options?.autoRefreshOnConnecting]);
    let consentBanks = rawConsentBanks;
    if (options?.prioritizePluggy) {
        consentBanks = hideBelvoDuplicates(consentBanks);
    }
    return {
        consentBanks,
        isLoading: resultV1.isLoading || resultV2.isLoading,
        error: resultV1.error || resultV2.error,
        refetch,
    };
};
const hideBelvoDuplicates = (consentBanks) => {
    const bankCodesWithPluggy = new Set(consentBanks.filter(bank => bank.partner === ConsentPartner.PLUGGY).map(bank => bank.externalBankCode));
    return consentBanks.filter(bank => bank.partner === ConsentPartner.PLUGGY || !bankCodesWithPluggy.has(bank.externalBankCode));
};
